
import { Component, Prop } from 'nuxt-property-decorator';
import AbstractInput from './abstractInput';

@Component({})
export default class Score extends AbstractInput {
  @Prop({ type: Number, default: 5 }) readonly max!: number;
  @Prop(Boolean) readonly disabled!: boolean;

  public readonly min: number = 0;

  public innerValue: string | string[] = '0';
  public isIndicatorShown: boolean = true;

  get isNone(): boolean {
    return this.valueAsNumber === 0;
  }

  get valueAsNumber(): number {
    return this.value ? parseInt(this.value as string) : 0;
  }

  get fillTransformStyle(): string {
    const valueInPercent = (100 * this.valueAsNumber) / this.max;
    return 'translate3d(' + valueInPercent + '%, 0, 0)';
  }

  public created(): void {
    this.innerValue = this.value === '' ? '0' : this.value;
  }

  public stepPosition(n: number): { left: string } {
    const valueInPercent = (100 * n) / this.max;
    return { left: `${valueInPercent}%` };
  }

  public triggerChange(value: string): void {
    const realValue = value === '0' ? '' : value;

    this.innerValue = value;
    this.$emit('input', realValue);
  }
}
